import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'team-management/devices';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);


export const DEVICE_LIST_GET = createApiNamespacedConstants('DEVICE_LIST_GET');
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
